export default {
  productImages: [],
  productImage: undefined,
};
